
import { arrayOf, nullable, oneOfType, shape, string } from 'vue-types';
import { imageShape } from '~/constants/PropTypes';
export const AuthorType = shape({
  name: oneOfType([string(), nullable()]),
  title: oneOfType([string(), nullable()]),
  image: arrayOf(shape(imageShape).loose),
}).loose;

export default {
  inheritAttrs: false,
  props: {
    author: AuthorType,
  },
  computed: {
    image() {
      return this.$first(this.author.image);
    },
  },
};
